// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"167":"e2c60ff3","197":"400c5b3a"}[chunkId] + ".js";
};